module.exports = __webpack_public_path__ + "static/img/6353_phase_function_Paper_Points.6f928c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6353_phase_function_Paper_Points.png
// module id = cZGh
// module chunks = 0